// Intalk Widget Actions
export const SHOW_INTALK_WIDGET = 'SHOW_INTALK_WIDGET';
export const HIDE_INTALK_WIDGET = 'HIDE_INTALK_WIDGET';
export const SET_INTALK_CALL_DATA = 'SET_INTALK_CALL_DATA';
export const SET_INTALK_IFRAME_READY = 'SET_INTALK_IFRAME_READY';
export const SET_INTALK_IFRAME_URL = 'SET_INTALK_IFRAME_URL';
export const SET_CALL_IN_PROGRESS = 'SET_CALL_IN_PROGRESS';

export const showIntalkWidget = (callData) => ({
    type: SHOW_INTALK_WIDGET,
    payload: callData
});

export const hideIntalkWidget = (payload) => ({
    type: HIDE_INTALK_WIDGET,
    payload: payload
});

export const setIntalkCallData = (callData) => ({
    type: SET_INTALK_CALL_DATA,
    payload: callData
});

export const setIntalkIframeReady = (isReady) => ({
    type: SET_INTALK_IFRAME_READY,
    payload: isReady
});

export const setIntalkIframeUrl = (url) => ({
    type: SET_INTALK_IFRAME_URL,
    payload: url
});

export const setCallInProgress = (isInProgress) => ({
    type: SET_CALL_IN_PROGRESS,
    payload: isInProgress
});
